import styles from "./index.module.css";
import Hint from "@/components/Hint";
import { useMediaQuery } from "@mantine/hooks";
import { theme } from "@/theme";
import React, { forwardRef } from "react";
import { QueryParams } from "@/constants/common";
import { useModifyQueryParams } from "@/hooks/useModifyQueryParams";

interface AsideHintProps {
  hintMessage: React.ReactElement | string;
}

export const AsideHint = forwardRef<HTMLDivElement, AsideHintProps>(({ hintMessage }, ref) => {
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints?.xl})`) ?? true;
  const { isQueryParamPresent, removeQueryParam } = useModifyQueryParams();

  const hint = isQueryParamPresent(QueryParams.pageHint, true) ? (
    <Hint message={hintMessage} onClose={() => removeQueryParam(QueryParams.pageHint)} />
  ) : null;

  const MobileHint = (
    <aside ref={ref} className={styles.aside}>
      {hint}
    </aside>
  );

  const DesktopHint = (
    <aside ref={ref} className={styles.aside}>
      <div className={styles.desktopHint}>{hint}</div>
    </aside>
  );

  return isDesktop ? DesktopHint : MobileHint;
});
